import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetJurisdictionsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetJurisdictionsQuery = { __typename?: 'query_root', jurisdictions: Array<{ __typename?: 'jurisdictions', id: any, name: string, short_name: string, state: string, county?: string | null, city?: string | null, ahj_type: string, primary_codes?: any | null, website_url?: string | null, notes?: string | null, active: boolean, created_at: any, updated_at: any }> };


export const GetJurisdictionsDocument = gql`
    query GetJurisdictions {
  jurisdictions(order_by: [{state: asc}, {county: asc}, {name: asc}]) {
    id
    name
    short_name
    state
    county
    city
    ahj_type
    primary_codes
    website_url
    notes
    active
    created_at
    updated_at
  }
}
    `;

/**
 * __useGetJurisdictionsQuery__
 *
 * To run a query within a React component, call `useGetJurisdictionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJurisdictionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJurisdictionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetJurisdictionsQuery(baseOptions?: Apollo.QueryHookOptions<GetJurisdictionsQuery, GetJurisdictionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJurisdictionsQuery, GetJurisdictionsQueryVariables>(GetJurisdictionsDocument, options);
      }
export function useGetJurisdictionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJurisdictionsQuery, GetJurisdictionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJurisdictionsQuery, GetJurisdictionsQueryVariables>(GetJurisdictionsDocument, options);
        }
export function useGetJurisdictionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetJurisdictionsQuery, GetJurisdictionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetJurisdictionsQuery, GetJurisdictionsQueryVariables>(GetJurisdictionsDocument, options);
        }
export type GetJurisdictionsQueryHookResult = ReturnType<typeof useGetJurisdictionsQuery>;
export type GetJurisdictionsLazyQueryHookResult = ReturnType<typeof useGetJurisdictionsLazyQuery>;
export type GetJurisdictionsSuspenseQueryHookResult = ReturnType<typeof useGetJurisdictionsSuspenseQuery>;
export type GetJurisdictionsQueryResult = Apollo.QueryResult<GetJurisdictionsQuery, GetJurisdictionsQueryVariables>;